import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Building2 } from "lucide-react";
import { CONTACT } from "../lib/shop";

export const Footer = () => (
  <footer className="mt-16 border-t border-border bg-primary text-primary-foreground" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-3 md:px-8">
      <div>
        <img src="/logo.webp" alt="CoreConnect" className="h-12 w-auto rounded-sm bg-white p-1" />
        <p className="mt-4 max-w-xs text-sm text-white/70">
          Quality electrical connection components for switchboard builders, electricians and industry. Sydney, Australia.
        </p>
      </div>
      <div>
        <h3 className="text-sm font-semibold uppercase tracking-wider text-accent">Quick Links</h3>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/" className="text-white/80 transition-colors hover:text-accent" data-testid="footer-products-link">Products</Link></li>
          <li><Link to="/cart" className="text-white/80 transition-colors hover:text-accent" data-testid="footer-cart-link">Cart</Link></li>
          <li><Link to="/contact" className="text-white/80 transition-colors hover:text-accent" data-testid="footer-contact-link">Contact Us</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="text-sm font-semibold uppercase tracking-wider text-accent">Contact</h3>
        <ul className="mt-4 space-y-3 text-sm text-white/80">
          <li className="flex items-center gap-2" data-testid="footer-phone">
            <Phone className="h-4 w-4 text-accent" /> {CONTACT.phone}
          </li>
          <li className="flex items-center gap-2" data-testid="footer-email">
            <Mail className="h-4 w-4 text-accent" /> {CONTACT.email}
          </li>
          <li className="flex items-center gap-2" data-testid="footer-location">
            <MapPin className="h-4 w-4 text-accent" /> {CONTACT.location}
          </li>
          <li className="flex items-center gap-2" data-testid="footer-abn">
            <Building2 className="h-4 w-4 text-accent" /> ABN {CONTACT.abn}
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
      © {new Date().getFullYear()} CoreConnect. All prices in AUD.
    </div>
  </footer>
);
